import {
	useAddEmployeeOvertimeEntryResponse,
	useCancelEmployeeOvertimeEntryRequest,
	useCreateEmployeeOvertimeEntryRequest,
	useDeleteEmployeeOvertimeEntryRequest,
	useGetEmployeeOvertimeEntryRequest,
	useGetEmployeeOvertimeEntryRequestById,
	useRevokeEmployeeOvertimeEntryRequest,
	useUpdateEmployeeOvertimeEntryRequest,
} from "../../../services/employee-overtime-entry-request.service";
import {
	useAddEmployeeWorkTimeResponse,
	useCancelEmployeeWorkTimeRequest,
	useCreateEmployeeWorkTimeRequest,
	useDeleteEmployeeWorkTimeRequest,
	useGetEmployeeWorkTimeRequest,
	useGetEmployeeWorkTimeRequestById,
	useRevokeEmployeeWorkTimeRequest,
	useUpdateEmployeeWorkTimeRequest,
} from "../../../services/employee-work-time-request.service";
import { TimeRequestKind } from "./data";

// The list hook for a kind of request, for useManageTableWithSearchParams
export const getTimeRequestListHook = (kind: TimeRequestKind) =>
	kind === "overtime"
		? useGetEmployeeOvertimeEntryRequest
		: useGetEmployeeWorkTimeRequest;

/** A request's details; only the given kind's query runs. */
export function useTimeRequestDetail(kind: TimeRequestKind, id?: number) {
	const overtime = useGetEmployeeOvertimeEntryRequestById(
		kind === "overtime" ? id : undefined,
	);
	const workTime = useGetEmployeeWorkTimeRequestById(
		kind === "workTime" ? id : undefined,
	);
	return {
		data: (kind === "overtime" ? overtime.data : workTime.data) as
			{ data: any } | undefined,
		isLoading: kind === "overtime" ? overtime.isLoading : workTime.isLoading,
	};
}

// Payloads differ by kind; the form building them knows which it is
type TimeRequestMutation = {
	mutate: (
		variables: any,
		options?: {
			onSuccess?: (response: { data: any }) => void;
			onSettled?: () => void;
		},
	) => void;
};

export type TimeRequestMutations = Record<
	"create" | "update" | "remove" | "respond" | "cancel" | "revoke",
	TimeRequestMutation
>;

/**
 * Mutations for a kind of request. Both kinds' hooks are created, as hooks
 * can't be called conditionally.
 */
export function useTimeRequestMutations(
	kind: TimeRequestKind,
): TimeRequestMutations {
	const overtime = {
		create: useCreateEmployeeOvertimeEntryRequest(),
		update: useUpdateEmployeeOvertimeEntryRequest(),
		remove: useDeleteEmployeeOvertimeEntryRequest(),
		respond: useAddEmployeeOvertimeEntryResponse(),
		cancel: useCancelEmployeeOvertimeEntryRequest(),
		revoke: useRevokeEmployeeOvertimeEntryRequest(),
	};
	const workTime = {
		create: useCreateEmployeeWorkTimeRequest(),
		update: useUpdateEmployeeWorkTimeRequest(),
		remove: useDeleteEmployeeWorkTimeRequest(),
		respond: useAddEmployeeWorkTimeResponse(),
		cancel: useCancelEmployeeWorkTimeRequest(),
		revoke: useRevokeEmployeeWorkTimeRequest(),
	};
	return (kind === "overtime" ? overtime : workTime) as TimeRequestMutations;
}
